/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Variance_Note_RequiredInputs */

const vi_stocktake_variance_note_required = /** @type {(inputs: Stocktake_Variance_Note_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bắt buộc nhập ghi chú cho mỗi dòng có cảnh báo lệch cao.`)
};

/**

* @param {Stocktake_Variance_Note_RequiredInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_variance_note_required = /** @type {((inputs?: Stocktake_Variance_Note_RequiredInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Variance_Note_RequiredInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_variance_note_required(inputs)
});